import { useState } from "react";
import { api, formatApiError, imageUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label = "Image" }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.storage_path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">{label}</div>
      {value ? (
        <div className="relative inline-block">
          <img src={imageUrl(value)} alt="" className="h-32 w-32 object-cover border border-border" />
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-foreground text-background flex items-center justify-center"
            data-testid="remove-image"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ) : (
        <label className="inline-flex items-center gap-2 cursor-pointer border border-dashed border-border px-4 py-3 text-sm hover:bg-secondary transition-colors" data-testid="upload-trigger">
          <Upload className="h-4 w-4" />
          {uploading ? "Uploading..." : "Choose image"}
          <input type="file" className="hidden" accept="image/*" onChange={handleFile} disabled={uploading} />
        </label>
      )}
    </div>
  );
}
